/* tslint:disable:indent */
import { SourceAppProfilAcheteurInfos } from '../../../../models/source-app-profil-acheteur-infos';
import {Annonceur} from './annonceur.pwd';
import {TypeAnn} from './type.ann';


export class Annonce {
  public ann: TypeAnn;
  public annonceur: Annonceur;
  public stepId: number; // ✅ FIX 2026-03-02: Encodé avec format: mainStep * 100 + subSection (ex: 4.2 -> 402)
  public isBOAMPorJOUE: boolean;
  public isSHALorPS: boolean;
  public eformsNotice: any;
  public sourceAppProfilAcheteurInfos: SourceAppProfilAcheteurInfos;
  public version: string; // ✅ FIX 2026-03-02: Utilisé pour encoder stepValue au format "SV:X"
  public prefillValues: any; 
  
  constructor() {
    this.annonceur = new Annonceur();
    this.ann = new TypeAnn();
    this.stepId = 0;
    this.isBOAMPorJOUE = false;
    this.isSHALorPS = false;
  }

}
